import { useQuery } from "@tanstack/react-query";
import Api from "../../features/one-query/services/ApiServices";

interface VideoLibProps {
  Category: number;
}

//Get inspiration video items.
const getInspirationLibraryVideoItems = async (props: VideoLibProps) => {
  const response = await Api.get(`/VideoLibrary?Category=${props.Category}`);
  return response.data;
};

const useGetInspirationLibraryVideoItems = (props: VideoLibProps) => {
  return useQuery({
    queryKey: ["getInspirationLibraryVideoItems", props.Category],
    queryFn: () => getInspirationLibraryVideoItems(props),
  });
};

// ============================================================================

//Get inspiration image items.
const getInspirationLibraryImageItems = async (props: VideoLibProps) => {
  const response = await Api.get(`/ImageLibrary?Category=${props.Category}`);
  return response.data;
};

const useGetInspirationLibraryImageItems = (props: VideoLibProps) => {
  return useQuery({
    queryKey: ["getInspirationLibraryImageItems", props.Category],
    queryFn: () => getInspirationLibraryImageItems(props),
  });
};

export {
  useGetInspirationLibraryVideoItems,
  useGetInspirationLibraryImageItems,
};